import { gql } from '@apollo/client';

export const GET_FUNDING_SOURCES = gql`
  query fundingSources($ids: [ID!], $state: State) {
    fundingSources(ids: $ids, state: $state) {
      id
      name
      disabled
      seq
      description
    }
  }
`;

export const ADD_FUNDING_SOURCE = gql`
  mutation addFundingSource($input: AddFundingSourceInput!) {
    addFundingSource(input: $input) {
      id
      name
      seq
      description
      disabled
    }
  }
`;

export const UPDATE_FUNDING_SOURCE = gql`
  mutation updateFundingSource($input: UpdateFundingSourceInput!) {
    updateFundingSource(input: $input) {
      id
      name
      seq
      description
      disabled
    }
  }
`;
